/*@ngInject*/
const SessionTimeoutController = function ($rootScope, $scope, $filter, $uibModal, $element, preferenceModel, localization, Idle, coreMediator, coreConstant, appTypeConfigurationModel) {

    $element.addClass('sessionTimeout');

    let translations,
        idleWarningTitle,
        sessionExpireTitle,
        modalInstance;

    localization.getTranslations().then(function (result) {
        translations = result;
        idleWarningTitle = _.get(translations, 'sessionTimeout.idleWarningTitle');
        sessionExpireTitle = _.get(translations, 'sessionTimeout.inactivityLogOutTitle');
    });

    function generateMessage(countDown) {
        let autoLogoutWarning = _.get(translations, 'sessionTimeout.autoLogoutWarning');
        autoLogoutWarning = _.replace(autoLogoutWarning, '{umsType}', _.get(translations, 'sessionTimeout.' + _.lowerFirst(appTypeConfigurationModel.getUserType())));
        autoLogoutWarning = _.replace(autoLogoutWarning, '{autoLogoutWarningMinutes}', preferenceModel.get('system.autoLogoutMinutes'));
        autoLogoutWarning = _.replace(autoLogoutWarning, '{countDown}', $filter('readableTime')(countDown));
        return autoLogoutWarning;
    }

    $scope.$on('IdleWarn', function (e, countdown) {
        let message = generateMessage(countdown);

        if (modalInstance) {
            $rootScope.$broadcast(coreConstant.event.UPDATE_SESSION_COUNTDOWN_MESSAGE, message);
        }
        else {
            displayModal(idleWarningTitle, message);
        }
    });

    $scope.$on('IdleTimeout', function () {
        let autoLogoutRedirectMessage = _.get(translations, 'sessionTimeout.autoLogoutRedirectMessage');
        autoLogoutRedirectMessage = _.replace(autoLogoutRedirectMessage, '{umsType}', _.get(translations, 'sessionTimeout.' + _.lowerFirst(appTypeConfigurationModel.getUserType())));
        coreMediator.logout(true);
        displayModal(sessionExpireTitle, autoLogoutRedirectMessage);
    });

    function closeOpenModal() {
        if (!_.isNil(modalInstance)) {
            modalInstance.close();
            modalInstance = null;
        }
    }

    function displayModal(title, message) {
        closeOpenModal();

        modalInstance = $uibModal.open({
            templateUrl: '/ui/modal/sessionTimeoutModal/sessionTimeoutModal.tpl.html',
            windowClass: 'sessionTimeoutModal',
            backdrop: 'static',
            controller: 'sessionTimeoutModalController',
            resolve: {
                title: function () {
                    return title;
                },
                message: function () {
                    return message;
                }
            }
        });
    }

    $scope.$on('IdleStart', function () {
        // Nothing
    });

    $scope.$on('IdleEnd', function () {
        closeOpenModal();
    });

    $scope.$on('Keepalive', function () {
        // Nothing
    });

    $scope.$on(coreConstant.event.START_IDLE, function () {
        closeOpenModal();
        Idle.watch();
        Idle.setIdle(parseInt(preferenceModel.get('system.autoLogoutMinutes')) * 60);
        Idle.setTimeout(parseInt(preferenceModel.get('system.autoLogoutWarningMinutes')) * 60);
    });

    $scope.$on(coreConstant.event.STOP_IDLE, function () {
        Idle.unwatch();
    });
};

angular.module('umCore')
    .controller('sessionTimeoutController', SessionTimeoutController)
    .config(function (TitleProvider) {
        TitleProvider.enabled(false);   // Disable the idle message in the HTML page title
    });
